import React from 'react';

import ItemVase from '../../assets/item_vase.webp';
import ItemBullockCart from '../../assets/item_bullock_cart.webp';
import ItemScript from '../../assets/item_script.webp';
import ItemHeadphones from '../../assets/item_headphones.webp';
import ItemTvUnit from '../../assets/item_tv_unit.webp';
import ItemSofa2 from '../../assets/item_sofa_2.webp';
import ItemMonk from '../../assets/item_monk.webp';

import ItemOttoman from '../../assets/item_recliner.webp';
import ItemCycle from '../../assets/item_st10.webp';
import ItemSpher from '../../assets/item_spher.webp';
import ItemKettle from '../../assets/item_delonghi.webp';

import ItemSofa3 from '../../assets/item_sofa_3.webp';
import ItemBangku from '../../assets/item_bangku.webp';
import ItemCoffeeTable from '../../assets/item_coffee_table.webp';
import ItemElephant from '../../assets/item_elephant.webp';
import ItemWatch from '../../assets/item_watch.webp';
import ItemSofa from '../../assets/item_sofa.webp';
import ItemDoll from '../../assets/item_doll_legs.webp';

import MediumItemVase from '../../assets/mobile/item_vase.webp';
import MediumItemBullockCart from '../../assets/mobile/item_bullock_cart.webp';
import MediumItemScript from '../../assets/mobile/item_script.webp';
import MediumItemHeadphones from '../../assets/mobile/item_headphones.webp';
import MediumItemTvUnit from '../../assets/mobile/item_tv_unit.webp';
import MediumItemSofa2 from '../../assets/mobile/item_sofa_2.webp';
import MediumItemMonk from '../../assets/mobile/item_monk.webp';

import MediumItemOttoman from '../../assets/mobile/item_recliner.webp';
import MediumItemCycle from '../../assets/mobile/item_st10.webp';
import MediumItemSpher from '../../assets/mobile/item_spher.webp';
import MediumItemKettle from '../../assets/mobile/item_delonghi.webp';

import MediumItemSofa3 from '../../assets/mobile/item_sofa_3.webp';
import MediumItemBangku from '../../assets/mobile/item_bangku.webp';
import MediumItemCoffeeTable from '../../assets/mobile/item_coffee_table.webp';
import MediumItemElephant from '../../assets/mobile/item_elephant.webp';
import MediumItemWatch from '../../assets/mobile/item_watch.webp';
import MediumItemSofa from '../../assets/mobile/item_sofa.webp';
import MediumItemDoll from '../../assets/mobile/item_doll_legs.webp';

import SmallItemVase from '../../assets/mobile/small/item_vase.webp';
import SmallItemBullockCart from '../../assets/mobile/small/item_bullock_cart.webp';
import SmallItemScript from '../../assets/mobile/small/item_script.webp';
import SmallItemHeadphones from '../../assets/mobile/small/item_headphones.webp';
import SmallItemTvUnit from '../../assets/mobile/small/item_tv_unit.webp';
import SmallItemSofa2 from '../../assets/mobile/small/item_sofa_2.webp';
import SmallItemMonk from '../../assets/mobile/small/item_monk.webp';

import SmallItemOttoman from '../../assets/mobile/small/item_recliner.webp';
import SmallItemCycle from '../../assets/mobile/small/item_st10.webp';
import SmallItemSpher from '../../assets/mobile/small/item_spher.webp';
import SmallItemKettle from '../../assets/mobile/small/item_delonghi.webp';

import SmallItemSofa3 from '../../assets/mobile/small/item_sofa_3.webp';
import SmallItemBangku from '../../assets/mobile/small/item_bangku.webp';
import SmallItemCoffeeTable from '../../assets/mobile/small/item_coffee_table.webp';
import SmallItemElephant from '../../assets/mobile/small/item_elephant.webp';
import SmallItemWatch from '../../assets/mobile/small/item_watch.webp';
import SmallItemSofa from '../../assets/mobile/small/item_sofa.webp';
import SmallItemDoll from '../../assets/mobile/small/item_doll_legs.webp';

const PRODUCTS_ROW_1 = [
  {
    image: [ItemVase, MediumItemVase, SmallItemVase],
    id: '8975a214-32bf-4fd9-815b-a44743662709',
    name: 'Echasse flower vase',
  },
  {
    image: [ItemBullockCart, MediumItemBullockCart, SmallItemBullockCart],
    id: '2c792545-2345-4f9b-bd69-d323cf7c9132',
    name: 'Kondapalli doll bullock cart',
  },
  {
    image: [ItemScript, MediumItemScript, SmallItemScript],
    id: '968c2f40-770c-411e-8dc1-633b0bcbd203',
    name: 'Script Ritz sofa',
  },
  {
    image: [ItemHeadphones, MediumItemHeadphones, SmallItemHeadphones],
    id: '8ecfee53-4fe9-4f0b-b398-4b2c9560261a',
    name: 'Bose headphones',
  },
  {
    image: [ItemTvUnit, MediumItemTvUnit, SmallItemTvUnit],
    id: 'a6a0b442-6b5f-4938-b4d3-6f9c1c323358',
    name: 'Holfred table - Scandinavian designs',
  },
  {
    image: [ItemSofa2, MediumItemSofa2, SmallItemSofa2],
    id: '729922f6-d550-43fe-a134-668f6d3154fc',
    name: 'William zanotta sofa - Scandinavian designs',
  },
  {
    image: [ItemMonk, MediumItemMonk, SmallItemMonk],
    id: '960f5752-a6ce-4e1e-bab5-aee83455e697',
    name: 'Miniso monk decorative item',
  },
];

const PRODUCTS_ROW_2 = [
  {
    image: [ItemOttoman, MediumItemOttoman, SmallItemOttoman],
    id: 'f5fa76ae-a094-412b-bc42-b67e94ada27a',
    name: 'Lounge and ottoman chair',
  },
  {
    image: [ItemCycle, MediumItemCycle, SmallItemCycle],
    id: 'bcc2654b-b1ec-4bd1-b483-ee69a02b9020',
    name: 'Decathlon ST10 bicycle',
  },
  {
    image: [ItemSpher, MediumItemSpher, SmallItemSpher],
    id: 'ed3cb6bd-ef69-489a-b2b9-a70e0f823353',
    name: 'Okamura Spher chair',
  },
  {
    image: [ItemKettle, MediumItemKettle, SmallItemKettle],
    id: 'b32a1cb4-0db4-4d2a-854a-ccf3092ae939',
    name: 'Delonghi KMix Kettle',
  },
];

const PRODUCTS_ROW_3 = [
  {
    image: [ItemSofa3, MediumItemSofa3, SmallItemSofa3],
    id: 'b76c7789-2bee-4109-8e26-3c7b3e257b3e',
    name: 'Orange sofa',
  },
  {
    image: [ItemBangku, MediumItemBangku, SmallItemBangku],
    id: '7b451845-62a9-44f1-95ce-b83635768df0',
    name: 'Alankaram bangku chair',
  },
  {
    image: [ItemCoffeeTable, MediumItemCoffeeTable, SmallItemCoffeeTable],
    id: 'd949dca1-b263-4e4b-8bd5-e46140842220',
    name: 'Iqrup and Ritz coffee table',
  },
  {
    image: [ItemDoll, MediumItemDoll, SmallItemDoll],
    id: '2f344fa0-11b5-4108-a75c-aae42a96bba0',
    name: 'Kondapalli dancing doll',
  },
  {
    image: [ItemWatch, MediumItemWatch, SmallItemWatch],
    id: 'd018c183-a9d4-47ba-b8e2-5dd18f4d77c6',
    name: 'Titan edge ceramic watch',
  },
  {
    image: [ItemSofa, MediumItemSofa, SmallItemSofa],
    id: '500b6a84-191f-4edc-8018-982a3fe687d7',
    name: 'Zanotta william single seater sofa',
  },
  {
    image: [ItemElephant, MediumItemElephant, SmallItemElephant],
    id: 'ce69da2d-5ab5-4ea4-b3a1-4c786afff6d1',
    name: 'Kondapalli Ambari Enugu doll',
  },
];

const SIZE_ATTRIBUTE = `(max-width: 680px) 90px, (max-width: 940px) 130px, (max-width: 1100px) 180px, (max-width: 1300px) 160px, (max-width: 1600px) 210px, 250px`;

class LandingValueProposition extends React.Component {
  render() {
    return (
      <div id="landing-vp">
        <div className="landing-vp-row1 landing-vp-row">
          {PRODUCTS_ROW_1.map(({ image, id, name }) => (
            <div key={id} className="landing-vp-item">
              <a
                className="landing-vp-item-inner"
                href={`https://cp.euclidxr.com/${id}`}
                target="_blank"
                rel="noreferrer">
                <img
                  src={image[0]}
                  srcSet={`${image[0]} 500w, ${image[1]} 250w, ${image[2]} 120w`}
                  width={500}
                  height={528}
                  className="landing-vp-item-img"
                  alt={name}
                  loading="lazy"
                  sizes={SIZE_ATTRIBUTE}
                />
              </a>
            </div>
          ))}
        </div>
        <div className="landing-vp-row2 landing-vp-row">
          {PRODUCTS_ROW_2.slice(0, PRODUCTS_ROW_2.length / 2).map(({ image, id, name }) => (
            <a
              key={id}
              href={`https://cp.euclidxr.com/${id}`}
              className="landing-vp-item"
              target="_blank"
              rel="noreferrer">
              <div className="landing-vp-item-inner">
                <img
                  src={image[0]}
                  srcSet={`${image[0]} 500w, ${image[1]} 250w`}
                  width={500}
                  height={528}
                  className="landing-vp-item-img"
                  alt={name}
                  loading="lazy"
                  sizes={SIZE_ATTRIBUTE}
                />
              </div>
            </a>
          ))}
          <div id="landing-vp-text">
            <h2>
              We help businesses and manufacturers leverage
              <br /> 3D technologies to enhance their product offering
            </h2>
            <p>(Click on a item to see live demo)</p>
          </div>
          {PRODUCTS_ROW_2.slice(PRODUCTS_ROW_2.length / 2, PRODUCTS_ROW_2.length).map(
            ({ image, id, name }) => (
              <a
                key={id}
                href={`https://cp.euclidxr.com/${id}`}
                className="landing-vp-item"
                target="_blank"
                rel="noreferrer">
                <div className="landing-vp-item-inner">
                  <img
                    src={image[0]}
                    srcSet={`${image[0]} 500w, ${image[1]} 250w`}
                    width={500}
                    height={528}
                    className="landing-vp-item-img"
                    alt={name}
                    loading="lazy"
                    sizes={SIZE_ATTRIBUTE}
                  />
                </div>
              </a>
            ),
          )}
        </div>
        <div className="landing-vp-row3 landing-vp-row">
          {PRODUCTS_ROW_3.map(({ image, id, name }) => (
            <a
              key={id}
              href={`https://cp.euclidxr.com/${id}`}
              className="landing-vp-item"
              target="_blank"
              rel="noreferrer">
              <div className="landing-vp-item-inner">
                <img
                  src={image[0]}
                  srcSet={`${image[0]} 500w, ${image[1]} 250w`}
                  width={500}
                  height={528}
                  className="landing-vp-item-img"
                  alt={name}
                  loading="lazy"
                  sizes={SIZE_ATTRIBUTE}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    );
  }
}

export default LandingValueProposition;
